// PERSONA FRAGRANCE INTELLIGENCE — Phase 2.2 keys (Four Paths + TWFH page)
export const P22 = {
  en: {
    // Ecosystem headline
    eco4_title: "One ecosystem. Four paths.",
    eco4_sub: "One ecosystem. Four ways to experience fragrance intelligence.",
    eco4_support:
      "Learn fragrance. Explore intelligence. Create personalized scent. Build and discover through a professional fragrance house.",

    // Path 01 — LEARN
    path_learn_no: "PATH 01",
    path_learn: "LEARN",
    path_learn_title: "IPTECHS Academy",
    path_learn_sub: "Fragrance Education & Professional Development",
    path_learn_desc:
      "Learn the art, science and technology of perfumery through structured fragrance education.",
    path_learn_cta: "EXPLORE IPTECHS",

    // Path 02 — EXPLORE
    path_explore_no: "PATH 02",
    path_explore: "EXPLORE",
    path_explore_title: "PERSONA AI PERFUMER",
    path_explore_sub: "Fragrance Intelligence & Consultation",
    path_explore_desc:
      "Explore fragrance knowledge, discover olfactory perspectives and consult with conversational AI.",
    path_explore_cta: "EXPLORE AI PERFUMER",

    // Path 03 — CREATE
    path_create_no: "PATH 03",
    path_create: "CREATE",
    path_create_title: "PERSONA PERFUMERY TECH",
    path_create_sub: "Personalized Fragrance Technology",
    path_create_desc:
      "Access the official PERSONA technology for personalized fragrance research and formulation.",
    path_create_cta: "ACCESS PERSONA PERFUMERY TECH",
    path_create_note:
      "Official personalized fragrance results come from PERSONA PERFUMERY TECH — not from PERSONA AI PERFUMER.",

    // Path 04 — CRAFT & BUSINESS
    path_craft_no: "PATH 04",
    path_craft: "CRAFT & BUSINESS",
    path_craft_title: "TWFH",
    path_craft_sub: "Fragrance House · Professional Services · Store",
    path_craft_desc:
      "From fragrance consulting and professional formulation to manufacturing solutions, fragrance materials and curated creations.",
    path_craft_cta: "EXPLORE TWFH",

    // TWFH page
    twfh_page_eyebrow: "PATH 04 · CRAFT & BUSINESS",
    twfh_page_title: "TWFH",
    twfh_page_subtitle: "Tubagus Wijaya Fragrance House",
    twfh_page_position: "Fragrance House · Professional Services · Store",
    twfh_page_intro:
      "TWFH is the commercial and craftsmanship layer of the PERSONA ecosystem — connecting fragrance consulting, professional formulation and curated fragrance creations.",

    twfh_services_title: "Professional Services",
    twfh_service_1_no: "01",
    twfh_service_1_title: "Factory Consulting",
    twfh_service_1_desc:
      "Consultation for establishing professional perfume manufacturing facilities.",
    twfh_service_2_no: "02",
    twfh_service_2_title: "Master Perfumer",
    twfh_service_2_desc:
      "Exclusive fragrance formulation and signature scent development based on royalty collaboration.",
    twfh_service_3_no: "03",
    twfh_service_3_title: "Professional Makloon",
    twfh_service_3_desc:
      "Professional perfume manufacturing services through production partners associated with TWFH.",

    twfh_store_title: "Store",
    twfh_store_1_no: "01",
    twfh_store_1_title: "Fragrance Oil",
    twfh_store_1_desc:
      "Fragrance materials for artisan perfumery and fragrance development.",
    twfh_store_2_no: "02",
    twfh_store_2_title: "TWFH Creations",
    twfh_store_2_desc: "Finished fragrance creations by Tubagus Wijaya.",
    twfh_store_3_no: "03",
    twfh_store_3_title: "IPTECHS Alumni",
    twfh_store_3_desc: "Selected fragrance creations from IPTECHS alumni.",
    twfh_store_4_no: "04",
    twfh_store_4_title: "Brand Partners",
    twfh_store_4_desc: "Curated products from selected fragrance brand partners.",

    twfh_boundary_title: "A note on Personalized Perfume",
    twfh_boundary_body:
      "Personalized Perfume orders are exclusively processed through PERSONA PERFUMERY TECH using the PERSONA PTC system. TWFH and PERSONA PERFUMERY TECH remain separate commercial flows.",

    // Nav
    nav_twfh: "TWFH",
  },
  id: {
    eco4_title: "Satu ekosistem. Empat jalur.",
    eco4_sub: "Satu ekosistem. Empat cara mengalami fragrance intelligence.",
    eco4_support:
      "Pelajari wewangian. Jelajahi intelijen. Ciptakan wewangian personal. Bangun dan temukan melalui fragrance house profesional.",

    path_learn_no: "PATH 01",
    path_learn: "LEARN",
    path_learn_title: "IPTECHS Academy",
    path_learn_sub: "Edukasi Wewangian & Pengembangan Profesional",
    path_learn_desc:
      "Pelajari seni, sains, dan teknologi perfumery melalui pendidikan wewangian yang terstruktur.",
    path_learn_cta: "JELAJAHI IPTECHS",

    path_explore_no: "PATH 02",
    path_explore: "EXPLORE",
    path_explore_title: "PERSONA AI PERFUMER",
    path_explore_sub: "Intelijen & Konsultasi Wewangian",
    path_explore_desc:
      "Jelajahi pengetahuan wewangian, temukan perspektif olfaktori, dan berkonsultasi dengan AI percakapan.",
    path_explore_cta: "JELAJAHI AI PERFUMER",

    path_create_no: "PATH 03",
    path_create: "CREATE",
    path_create_title: "PERSONA PERFUMERY TECH",
    path_create_sub: "Teknologi Wewangian Personal",
    path_create_desc:
      "Akses teknologi resmi PERSONA untuk riset dan formulasi wewangian personal.",
    path_create_cta: "AKSES PERSONA PERFUMERY TECH",
    path_create_note:
      "Hasil wewangian personal resmi berasal dari PERSONA PERFUMERY TECH — bukan dari PERSONA AI PERFUMER.",

    path_craft_no: "PATH 04",
    path_craft: "CRAFT & BUSINESS",
    path_craft_title: "TWFH",
    path_craft_sub: "Fragrance House · Layanan Profesional · Store",
    path_craft_desc:
      "Dari fragrance consulting dan formulasi profesional hingga solusi manufaktur, bahan wewangian, dan kreasi terkurasi.",
    path_craft_cta: "JELAJAHI TWFH",

    twfh_page_eyebrow: "PATH 04 · CRAFT & BUSINESS",
    twfh_page_title: "TWFH",
    twfh_page_subtitle: "Tubagus Wijaya Fragrance House",
    twfh_page_position: "Fragrance House · Layanan Profesional · Store",
    twfh_page_intro:
      "TWFH adalah lapisan komersial dan craftsmanship dalam ekosistem PERSONA — menghubungkan fragrance consulting, formulasi profesional, dan kreasi wewangian terkurasi.",

    twfh_services_title: "Layanan Profesional",
    twfh_service_1_no: "01",
    twfh_service_1_title: "Factory Consulting",
    twfh_service_1_desc:
      "Konsultasi untuk pendirian fasilitas manufaktur parfum profesional.",
    twfh_service_2_no: "02",
    twfh_service_2_title: "Master Perfumer",
    twfh_service_2_desc:
      "Formulasi wewangian eksklusif dan pengembangan signature scent berbasis kolaborasi royalti.",
    twfh_service_3_no: "03",
    twfh_service_3_title: "Professional Makloon",
    twfh_service_3_desc:
      "Layanan manufaktur parfum profesional melalui mitra produksi yang berafiliasi dengan TWFH.",

    twfh_store_title: "Store",
    twfh_store_1_no: "01",
    twfh_store_1_title: "Fragrance Oil",
    twfh_store_1_desc:
      "Bahan wewangian untuk perfumery artisan dan pengembangan aroma.",
    twfh_store_2_no: "02",
    twfh_store_2_title: "TWFH Creations",
    twfh_store_2_desc: "Kreasi wewangian jadi karya Tubagus Wijaya.",
    twfh_store_3_no: "03",
    twfh_store_3_title: "IPTECHS Alumni",
    twfh_store_3_desc: "Kreasi wewangian pilihan dari alumni IPTECHS.",
    twfh_store_4_no: "04",
    twfh_store_4_title: "Brand Partners",
    twfh_store_4_desc: "Produk terkurasi dari brand mitra wewangian pilihan.",

    twfh_boundary_title: "Catatan tentang Personalized Perfume",
    twfh_boundary_body:
      "Pemesanan Personalized Perfume diproses secara eksklusif melalui PERSONA PERFUMERY TECH menggunakan sistem PERSONA PTC. TWFH dan PERSONA PERFUMERY TECH tetap berupa alur komersial yang terpisah.",

    nav_twfh: "TWFH",
  },
  fr: {
    eco4_title: "Un écosystème. Quatre voies.",
    eco4_sub: "Un écosystème. Quatre façons de vivre l'intelligence olfactive.",
    eco4_support:
      "Apprendre. Explorer. Créer votre parfum personnalisé. Construire et découvrir à travers une maison de parfum professionnelle.",

    path_learn_no: "PATH 01",
    path_learn: "LEARN",
    path_learn_title: "IPTECHS Academy",
    path_learn_sub: "Éducation olfactive & développement professionnel",
    path_learn_desc:
      "Apprenez l'art, la science et la technologie de la parfumerie à travers une éducation olfactive structurée.",
    path_learn_cta: "EXPLORER IPTECHS",

    path_explore_no: "PATH 02",
    path_explore: "EXPLORE",
    path_explore_title: "PERSONA AI PERFUMER",
    path_explore_sub: "Intelligence & consultation olfactive",
    path_explore_desc:
      "Explorez le savoir parfumier, découvrez de nouvelles perspectives olfactives et consultez une IA conversationnelle.",
    path_explore_cta: "EXPLORER AI PERFUMER",

    path_create_no: "PATH 03",
    path_create: "CREATE",
    path_create_title: "PERSONA PERFUMERY TECH",
    path_create_sub: "Technologie olfactive personnalisée",
    path_create_desc:
      "Accédez à la technologie officielle PERSONA pour la recherche et la formulation olfactive personnalisée.",
    path_create_cta: "ACCÉDER À PERSONA PERFUMERY TECH",
    path_create_note:
      "Les résultats officiels de parfum personnalisé proviennent de PERSONA PERFUMERY TECH — pas de PERSONA AI PERFUMER.",

    path_craft_no: "PATH 04",
    path_craft: "CRAFT & BUSINESS",
    path_craft_title: "TWFH",
    path_craft_sub: "Maison de parfum · Services professionnels · Boutique",
    path_craft_desc:
      "Du conseil olfactif à la formulation professionnelle, jusqu'aux solutions de fabrication, matières premières et créations sélectionnées.",
    path_craft_cta: "EXPLORER TWFH",

    twfh_page_eyebrow: "PATH 04 · CRAFT & BUSINESS",
    twfh_page_title: "TWFH",
    twfh_page_subtitle: "Tubagus Wijaya Fragrance House",
    twfh_page_position: "Maison de parfum · Services professionnels · Boutique",
    twfh_page_intro:
      "TWFH est la strate commerciale et artisanale de l'écosystème PERSONA — connectant conseil olfactif, formulation professionnelle et créations sélectionnées.",

    twfh_services_title: "Services Professionnels",
    twfh_service_1_no: "01",
    twfh_service_1_title: "Factory Consulting",
    twfh_service_1_desc:
      "Conseil pour la mise en place d'unités de fabrication professionnelles de parfum.",
    twfh_service_2_no: "02",
    twfh_service_2_title: "Master Perfumer",
    twfh_service_2_desc:
      "Formulation olfactive exclusive et développement de parfum signature en collaboration royalty.",
    twfh_service_3_no: "03",
    twfh_service_3_title: "Professional Makloon",
    twfh_service_3_desc:
      "Services de fabrication professionnelle de parfum via des partenaires de production affiliés à TWFH.",

    twfh_store_title: "Boutique",
    twfh_store_1_no: "01",
    twfh_store_1_title: "Fragrance Oil",
    twfh_store_1_desc:
      "Matières premières olfactives pour la parfumerie artisanale et le développement.",
    twfh_store_2_no: "02",
    twfh_store_2_title: "TWFH Creations",
    twfh_store_2_desc: "Créations olfactives finies signées Tubagus Wijaya.",
    twfh_store_3_no: "03",
    twfh_store_3_title: "IPTECHS Alumni",
    twfh_store_3_desc: "Créations olfactives sélectionnées d'alumni IPTECHS.",
    twfh_store_4_no: "04",
    twfh_store_4_title: "Brand Partners",
    twfh_store_4_desc: "Produits sélectionnés de marques partenaires.",

    twfh_boundary_title: "À propos du Personalized Perfume",
    twfh_boundary_body:
      "Les commandes de Personalized Perfume sont exclusivement traitées via PERSONA PERFUMERY TECH avec le système PERSONA PTC. TWFH et PERSONA PERFUMERY TECH restent des flux commerciaux distincts.",

    nav_twfh: "TWFH",
  },
};

export default P22;
